module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/740d2ffdc270a38f10bee14e66cf2372.png";